var _excluded = ["size", "color", "style", "className", "spin", "rotate"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from 'classnames';
import * as React from 'react';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FoxIconDart1Core = function FoxIconDart1Core(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false",
    role: "img"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M535.648 65.12a42.048 42.048 0 0 0-29.312 12.064l-0.416 0.32-274.88 158.88 274.112 274.112v0.192l329.6 329.6 62.816-113.152-226.592-543.904-105.6-105.6a41.792 41.792 0 0 0-29.664-12.416l-0.064-0.096z",
      fill: "#66C3FA"
    }), /*#__PURE__*/_jsx("path", {
      d: "M232 235.264l-158.784 274.56-0.32 0.448a41.6 41.6 0 0 0 0.288 58.976L204.8 700.864l514.688 202.464 116.352-64.64-3.2-3.2h-0.8l-322.656-323.2H508.8L232 235.264z",
      fill: "#215896"
    }), /*#__PURE__*/_jsx("path", {
      d: "M230.144 235.616l280.448 280.736h0.416l322.784 323.2 122.848-23.424 0.16-363.616-129.728-127.136a208.672 208.672 0 0 0-115.968-51.712v-1.408L230.144 235.616z",
      fill: "#235997"
    }), /*#__PURE__*/_jsx("path", {
      d: "M232.192 237.12l280.576 280.576v0.416l322.944 322.944-23.488 122.88h-363.52l-127.072-129.824a208.704 208.704 0 0 1-51.648-116h-1.408L232.192 237.152z",
      fill: "#58B6F0"
    })]
  }));
};
var Memo = /*#__PURE__*/memo(FoxIconDart1Core);
/**
 * ![FoxIconDart1](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCI+PHBhdGggZD0iTTUzNS42NDggNjUuMTJhNDIuMDQ4IDQyLjA0OCAwIDAgMC0yOS4zMTIgMTIuMDY0bC0wLjQxNiAwLjMyLTI3NC44OCAxNTguODggMjc0LjExMiAyNzQuMTEydjAuMTkybDMyOS42IDMyOS42IDYyLjgxNi0xMTMuMTUyLTIyNi41OTItNTQzLjkwNC0xMDUuNi0xMDUuNmE0MS43OTIgNDEuNzkyIDAgMCAwLTI5LjY2NC0xMi40MTZsLTAuMDY0LTAuMDk2eiIgZmlsbD0iIzY2QzNGQSI+PC9wYXRoPjxwYXRoIGQ9Ik0yMzIgMjM1LjI2NGwtMTU4Ljc4NCAyNzQuNTYtMC4zMiAwLjQ0OGE0MS42IDQxLjYgMCAwIDAgMC4yODggNTguOTc2TDIwNC44IDcwMC44NjRsNTE0LjY4OCAyMDIuNDY0IDExNi4zNTItNjQuNjQtMy4yLTMuMmgtMC44bC0zMjIuNjU2LTMyMy4ySDUwOC44TDIzMiAyMzUuMjY0eiIgZmlsbD0iIzIxNTg5NiI+PC9wYXRoPjxwYXRoIGQ9Ik0yMzAuMTQ0IDIzNS42MTZsMjgwLjQ0OCAyODAuNzM2aDAuNDE2bDMyMi43ODQgMzIzLjIgMTIyLjg0OC0yMy40MjQgMC4xNi0zNjMuNjE2LTEyOS43MjgtMTI3LjEzNmEyMDguNjcyIDIwOC42NzIgMCAwIDAtMTE1Ljk2OC01MS43MTJ2LTEuNDA4TDIzMC4xNDQgMjM1LjYxNnoiIGZpbGw9IiMyMzU5OTciPjwvcGF0aD48cGF0aCBkPSJNMjMyLjE5MiAyMzcuMTJsMjgwLjU3NiAyODAuNTc2djAuNDE2bDMyMi45NDQgMzIyLjk0NC0yMy40ODggMTIyLjg4aC0zNjMuNTJsLTEyNy4wNzItMTI5LjgyNGEyMDguNzA0IDIwOC43MDQgMCAwIDEtNTEuNjQ4LTExNmgtMS40MDhMMjMyLjE5MiAyMzcuMTUyeiIgZmlsbD0iIzU4QjZGMCI+PC9wYXRoPjwvc3ZnPg==) 
 **/
export default function FoxIconDart1(_ref) {
  var size = _ref.size,
    color = _ref.color,
    style = _ref.style,
    className = _ref.className,
    spin = _ref.spin,
    rotate = _ref.rotate,
    rest = _objectWithoutProperties(_ref, _excluded);
  var svgStyle = React.useMemo(function () {
    return rotate ? {
      msTransform: "rotate(".concat(String(rotate), "deg)"),
      transform: "rotate(".concat(String(rotate), "deg)")
    } : undefined;
  }, [rotate]);
  var customStyle = React.useMemo(function () {
    var tmp = {};
    if (size !== undefined) {
      tmp.fontSize = size;
    }
    if (color !== undefined) {
      tmp.color = color;
    }
    return tmp;
  }, [size, color, rotate]);
  var realStyle = React.useMemo(function () {
    if (style) {
      return _objectSpread(_objectSpread({}, customStyle), style);
    }
    return customStyle;
  }, [style, customStyle]);
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
    role: "img",
    className: classNames("appicon app_icon", className, spin ? "appicon-spin" : ""),
    style: realStyle
  }, rest), {}, {
    children: /*#__PURE__*/_jsx(Memo, {
      style: svgStyle
    })
  }));
}